/**
 * @generated SignedSource<<2d3472e68e3af50281ca38f40cfa8e19>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfile$data = {
  readonly accountId: string;
  readonly name: string;
  readonly picture: AGG$URL;
  readonly " $fragmentType": "UserProfile";
};
export type UserProfile$key = {
  readonly " $data"?: UserProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserProfile",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "picture"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "e5b1cbac10bb1a4e09933419919561f8";

export default node;
